import React from 'react';
import SaudiSidebar from './SaudiSidebar';
import SaudiHeader from './SaudiHeader';
import QawaemListToolbarHoist from '../components/QawaemListToolbarHoist';
import { SaudiSidebarLayoutProvider, useSaudiSidebarLayout } from '../context/SaudiSidebarLayoutContext';
import { SaudiDateFilterProvider } from '../context/SaudiDateFilterContext';
import './saudi-qawaem.css';

function SaudiLayoutShell({ children }) {
  const { open, close } = useSaudiSidebarLayout();

  return (
    <div className="console-app-root saudi-app-root h-screen flex bg-console-bg overflow-hidden" dir="rtl">
      {open ? (
        <button
          type="button"
          className="fixed inset-0 z-[9998] bg-[#2e452e]/20 backdrop-blur-[1px] lg:hidden"
          aria-label="إغلاق القائمة"
          onClick={close}
        />
      ) : null}

      <SaudiSidebar />

      <div className="flex-1 flex flex-col min-h-0 min-w-0">
        <SaudiHeader />
        <main className="console-main-scroll flex-1 p-6 overflow-y-auto overflow-x-hidden qawaem-main-content">
          <QawaemListToolbarHoist />
          {children}
        </main>
      </div>
      <div id="Qawaem-datepicker-portal" aria-hidden="true" />
    </div>
  );
}

/**
 * Qawaem-style shell for Saudi white-label ERP.
 */
export default function SaudiLayout({ children }) {
  return (
    <SaudiSidebarLayoutProvider>
      <SaudiDateFilterProvider>
        <SaudiLayoutShell>{children}</SaudiLayoutShell>
      </SaudiDateFilterProvider>
    </SaudiSidebarLayoutProvider>
  );
}
